import { render, staticRenderFns } from "./DocumentSalesAnalysis.vue?vue&type=template&id=92222914"
import script from "./DocumentSalesAnalysis.vue?vue&type=script&lang=js"
export * from "./DocumentSalesAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports